// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ml[data-v-078a01c6] {\n  margin-left: 10px;\n}\n.app-container[data-v-078a01c6] {\n  height: calc(100vh - 126px);\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
